import { slugify } from '@/subsystems/layout/utils/layout-utils'

export function nextAgentId(label: string, existingIds: string[]): string {
  const base = slugify(label) || 'agent'
  const used = new Set(existingIds)
  if (!used.has(base)) return base

  let suffix = 2
  while (used.has(`${base}-${suffix}`)) suffix += 1
  return `${base}-${suffix}`
}
